import type { ComponentPropsWithoutRef, FC } from 'react';
import styled from 'styled-components';
import { Colors } from 'src/styles';
import { cn } from 'src/utils/cn';

export const Divider = styled.hr`
  width: 100%;
  margin: 0.75rem 0;
  border: none;
  border-top: 0.1rem solid ${Colors.brandLight3};
`;

export const CardDivider = styled.hr`
  width: calc(100% + 3rem);
  margin: 0 -1.5rem;
  border: none;
  border-top: 0.1rem solid ${Colors.brandLight3};
`;

export const VerticalDivider: FC<ComponentPropsWithoutRef<'div'>> = (props) => (
  <div
    {...props}
    className={cn(
      `
        h-full w-[0.1rem] bg-border-surface-minimal
        legacy:bg-legacy-brand-border
      `,
      props.className
    )}
  />
);
